import {
    REQUEST_PAYMENTTERMS,
    FETCH_PAYMENTTERMS_SUCCESS,
    FETCH_PAYMENTTERMS_FAILURE,
    SELECT_PAYMENTTERM,
    RESET_CURRENT_PAYMENTTERM,
    RESET_CREATE_PAYMENT_TERM,
    RESET_EDIT_PAYMENT_TERM,
    REQUEST_CREATING_PAYMENT_TERM,
    CREATE_PAYMENT_TERM_SUCCESS,
    CREATE_PAYMENT_TERM_FAILURE,
    REQUEST_EDITING_PAYMENT_TERM,
    EDIT_PAYMENT_TERM_SUCCESS,
    EDIT_PAYMENT_TERM_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentPaymentTerm: null,
    isLoading: false,
    error: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_PAYMENTTERMS:
            return { ...state, error: null, isLoading: true };
        case FETCH_PAYMENTTERMS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PAYMENTTERMS_FAILURE:
            const error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_PAYMENTTERM:
            return { ...state, currentPaymentTerm: action.payload };
        case RESET_CURRENT_PAYMENTTERM:
            return { ...state, currentPaymentTerm: null };
        case REQUEST_CREATING_PAYMENT_TERM:
            return { ...state, isCreating: true, createError: null, created: false };
        case CREATE_PAYMENT_TERM_SUCCESS:
            return { ...state, isCreating: false, createError: null, created: true };
        case CREATE_PAYMENT_TERM_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, createError: createError, created: false };
        case RESET_CREATE_PAYMENT_TERM:
          return { ...state, isCreating: false, createError: null, created: false };
        case REQUEST_EDITING_PAYMENT_TERM:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_PAYMENT_TERM_SUCCESS:
            return { ...state, isEditing: false, editError: null, edited: true };
        case EDIT_PAYMENT_TERM_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, editError: editError, edited: false };
        case RESET_EDIT_PAYMENT_TERM:
          return { ...state, isEditing: false, editError: null, edited: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/paymentTerms_reducer.js